import { useSuspenseQuery } from "@tanstack/react-query"
import { trpc } from "app/trpc"
import { parseAsStringEnum, useQueryState } from "nuqs"
import { useCurrentUser } from "app/core/hooks/useCurrentUser"
import { useCurrentOrganization } from "app/core/hooks/useCurrentOrganization"
import {
  OrganizationUserRole,
  SubscriptionType,
  SupportContentType,
} from "db/enums"

export default function useSupportContent({
  supportContentType,
}: {
  supportContentType: SupportContentType | null
}) {
  const currentUser = useCurrentUser()
  const currentOrganization = useCurrentOrganization()

  const [subscriptionType] = useQueryState(
    "subscriptionType",
    parseAsStringEnum<SubscriptionType>(
      Object.values(SubscriptionType) as SubscriptionType[]
    )
  )

  const [organizationUserRole] = useQueryState(
    "organizationUserRole",
    parseAsStringEnum<OrganizationUserRole>(
      Object.values(OrganizationUserRole) as OrganizationUserRole[]
    )
  )

  const { data: supportContent, isLoading } = useSuspenseQuery({
    ...trpc.support.getSupportButtonContent.queryOptions({
      subscriptionType:
        currentUser?.role === "ADMIN"
          ? subscriptionType || "SCHOOL_SUBSCRIPTION"
          : (currentOrganization?.subscription
              .subscriptionType as SubscriptionType | null),
      organizationUserRole:
        currentUser?.role === "ADMIN"
          ? organizationUserRole || OrganizationUserRole.MANAGER
          : currentUser?.organizationUsers?.[0]?.role || null,
      supportContentType: supportContentType as SupportContentType,
    }),
    staleTime: currentUser?.role === "ADMIN" ? 0 : 1000 * 60 * 15, // 1 hour
    // enabled: supportContentType !== null,
  })

  if (!supportContentType) {
    return { supportContent: null, isLoading: false }
  }

  return { supportContent, isLoading }
}
